export default __webpack_public_path__ + "static/media/close.3645e14d.svg";